import { MaintenanceWindowManuallyApprovedPatchesSelectorWebComponent } from './component/MaintenanceWindowManuallyApprovedPatchesSelectorWebComponent';
import { WEB_COMPONENT_MAINTENANCE_WINDOW_MANUALLY_APPROVED_PATCHES_SELECTOR } from '../../webcomponents.constants';

export { MaintenanceWindowManuallyApprovedPatchesSelectorWebComponent };

window.customElements.define(
  WEB_COMPONENT_MAINTENANCE_WINDOW_MANUALLY_APPROVED_PATCHES_SELECTOR,
  MaintenanceWindowManuallyApprovedPatchesSelectorWebComponent
);
